import React, {Component} from 'react';
import {connect} from "react-redux";
import {addSubField} from "../../../../../store/actions/subFields";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import ParametersNotice from "../../Parameters/ParametersNotice";
import { FieldGroup } from '../FieldGroup';
import FieldGroups from '../FieldGroups';
import getFieldFactory from '../../Endpoint/FieldFactory';

class Basic extends Component {

	render() {

		const { settings } = this.props;

		return (
			<FieldGroupContext.Consumer>

				{({ endpointId, endpoint, currentItem, action }) => (

						<React.Fragment>
							<h3>Basic Information</h3>
							<p>Configure the basic information of the REST request, such as method and authentication type.</p>

							<ParametersNotice parameters={endpoint.parameters}/>

							{settings.endpoints[endpointId].restApiCall[currentItem].basic.map(
								(field, index) => <FieldGroup key={index} label={field.label} fields={field.fields} group="basic" groupId={index} currentItem={currentItem} action={action}/>
							)}

						</React.Fragment>
				)}

			</FieldGroupContext.Consumer>
		);
	}
}

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(Basic);
